import request from '../utils/request'

export function getDashboardOverview() {
  return request({
    url: '/api/admin/platform/dashboard-overview',
    method: 'get'
  })
}

export function getArtistUsers(params) {
  return request({
    url: '/api/admin/platform/artist-users',
    method: 'get',
    params
  })
}

export function getArtistUserDetail(id) {
  return request({
    url: `/api/admin/platform/artist-users/${id}`,
    method: 'get'
  })
}

export function banArtistUser(id) {
  return request({
    url: `/api/admin/platform/artist-users/${id}/ban`,
    method: 'post'
  })
}

export function unbanArtistUser(id) {
  return request({
    url: `/api/admin/platform/artist-users/${id}/unban`,
    method: 'post'
  })
}

export function adjustArtistUserExposure(id, data) {
  return request({
    url: `/api/admin/platform/artist-users/${id}/adjust-exposure`,
    method: 'post',
    data
  })
}

export function getMerchantUsers(params) {
  return request({
    url: '/api/admin/platform/merchant-users',
    method: 'get',
    params
  })
}

export function getMerchantUserDetail(id) {
  return request({
    url: `/api/admin/platform/merchant-users/${id}`,
    method: 'get'
  })
}

export function banMerchantUser(id) {
  return request({
    url: `/api/admin/platform/merchant-users/${id}/ban`,
    method: 'post'
  })
}

export function unbanMerchantUser(id) {
  return request({
    url: `/api/admin/platform/merchant-users/${id}/unban`,
    method: 'post'
  })
}

export function getPlatformOrders(params) {
  return request({
    url: '/api/admin/platform/orders',
    method: 'get',
    params
  })
}

export function getPlatformOrderDetail(id) {
  return request({
    url: `/api/admin/platform/orders/${id}`,
    method: 'get'
  })
}

export function closePlatformOrder(data) {
  return request({
    url: '/api/admin/platform/orders/close',
    method: 'post',
    data
  })
}

export function deletePlatformOrder(id) {
  return request({
    url: `/api/admin/platform/orders/${id}/delete`,
    method: 'post'
  })
}

export function getPlatformCommissionRules(params) {
  return request({
    url: '/api/admin/platform/orders/commission-rules',
    method: 'get',
    params
  })
}

export function createPlatformCommissionRule(data) {
  return request({
    url: '/api/admin/platform/orders/commission-rules',
    method: 'post',
    data
  })
}

export function savePlatformCommissionRule(id, data) {
  return request({
    url: `/api/admin/platform/orders/commission-rules/${id}`,
    method: 'post',
    data
  })
}

export function deletePlatformCommissionRule(id) {
  return request({
    url: `/api/admin/platform/orders/commission-rules/${id}/delete`,
    method: 'post'
  })
}

export function getFinanceTransactions(params) {
  return request({
    url: '/api/admin/platform/finance/transactions',
    method: 'get',
    params
  })
}

export function getFinanceTransactionDetail(id) {
  return request({
    url: `/api/admin/platform/finance/transactions/${id}`,
    method: 'get'
  })
}

export function getPrivateMessageSessions(params) {
  return request({
    url: '/api/admin/platform/private-messages/sessions',
    method: 'get',
    params
  })
}

export function getPrivateMessageSessionDetail(sessionId) {
  return request({
    url: `/api/admin/platform/private-messages/sessions/${sessionId}`,
    method: 'get'
  })
}

export function getPrivateMessageSessionMessages(sessionId) {
  return request({
    url: `/api/admin/platform/private-messages/sessions/${sessionId}/messages`,
    method: 'get'
  })
}

export function banPrivateMessageSession(sessionId, data) {
  return request({
    url: `/api/admin/platform/private-messages/sessions/${sessionId}/ban`,
    method: 'post',
    data
  })
}

export function unbanPrivateMessageSession(sessionId) {
  return request({
    url: `/api/admin/platform/private-messages/sessions/${sessionId}/unban`,
    method: 'post'
  })
}

export function sendPrivateMessageSystemNotice(sessionId, data) {
  return request({
    url: `/api/admin/platform/private-messages/sessions/${sessionId}/system-send`,
    method: 'post',
    data
  })
}

export function getCustomerServiceDashboard() {
  return request({
    url: '/api/admin/customer-service/dashboard/queue',
    method: 'get'
  })
}

export function getCustomerServiceSessions(params) {
  return request({
    url: '/api/admin/customer-service/sessions',
    method: 'get',
    params
  })
}

export function getCustomerServiceSession(sessionId) {
  return request({
    url: `/api/admin/customer-service/sessions/${sessionId}`,
    method: 'get'
  })
}

export function getCustomerServiceMessages(sessionId) {
  return request({
    url: `/api/admin/customer-service/sessions/${sessionId}/messages`,
    method: 'get'
  })
}

export function takeCustomerServiceSession(sessionId) {
  return request({
    url: `/api/admin/customer-service/sessions/${sessionId}/take`,
    method: 'post'
  })
}

export function sendCustomerServiceMessage(sessionId, data) {
  return request({
    url: `/api/admin/customer-service/sessions/${sessionId}/send`,
    method: 'post',
    data
  })
}

export function readCustomerServiceSession(sessionId) {
  return request({
    url: `/api/admin/customer-service/sessions/${sessionId}/read`,
    method: 'post'
  })
}

export function closeCustomerServiceSession(sessionId) {
  return request({
    url: `/api/admin/customer-service/sessions/${sessionId}/close`,
    method: 'post'
  })
}

export function getCustomerServiceWorkTime() {
  return request({
    url: '/api/admin/customer-service/work-time',
    method: 'get'
  })
}

export function saveCustomerServiceWorkTime(data) {
  return request({
    url: '/api/admin/customer-service/work-time',
    method: 'post',
    data
  })
}

export function getMembershipPlans() {
  return request({
    url: '/api/admin/membership/plans',
    method: 'get'
  })
}

export function saveMembershipPlan(id, data) {
  return request({
    url: `/api/admin/membership/plans/${id}`,
    method: 'post',
    data
  })
}

export function getMembershipBenefits() {
  return request({
    url: '/api/admin/membership/benefits',
    method: 'get'
  })
}

export function createMembershipBenefit(data) {
  return request({
    url: '/api/admin/membership/benefits',
    method: 'post',
    data
  })
}

export function saveMembershipBenefit(id, data) {
  return request({
    url: `/api/admin/membership/benefits/${id}`,
    method: 'post',
    data
  })
}

export function deleteMembershipBenefit(id) {
  return request({
    url: `/api/admin/membership/benefits/${id}/delete`,
    method: 'post'
  })
}

export function getNoticeExposureConfig() {
  return request({
    url: '/api/admin/notice-exposure/config',
    method: 'get'
  })
}

export function saveNoticeExposureConfig(data) {
  return request({
    url: '/api/admin/notice-exposure/config',
    method: 'post',
    data
  })
}

export function getNoticeExposureRecharges(params) {
  return request({
    url: '/api/admin/notice-exposure/recharges',
    method: 'get',
    params
  })
}

export function getNoticeExposureAdjustRecords(params) {
  return request({
    url: '/api/admin/notice-exposure/adjust-records',
    method: 'get',
    params
  })
}

export function getNoticeExposureNotices(params) {
  return request({
    url: '/api/admin/notice-exposure/notices',
    method: 'get',
    params
  })
}

export function adjustNoticeExposure(data) {
  return request({
    url: '/api/admin/notice-exposure/adjust',
    method: 'post',
    data
  })
}
